import React from "react";
import CustomCheckBox from "./CustomCheckBox";
import MetricsRuleView from "./MetricsRuleView";
import "./MetricCategoryTreeView.css";
import { flattenDeep } from "lodash";
import { findParentIdsBottomToTop } from "../../Utils/helper";
import CustomReactTooltip from "../../Components/CustomReactTooltip";

function MetricCategoryTreeView({
  treeData,
  setTreeData,
  title,
  checkedIds,
  setCheckedIds,
  expandedIds,
  setExpandIds,
  rule_view,
  metrics,
  isMetrics,
  setDataChange,
  IsEdit,
  groups,
  isLobTooltip = false,
  checkedSubgroupIds,
  forSubGroup = true,
}) {
  const setExpandedSegments = id => {
    setExpandIds(id);
  };

  const handleMetricsTrigger = checked => {
    setCheckedIds(checked);

    if (IsEdit) {
      setDataChange(true);
    }
  };

  return (
    <div
      className={rule_view ? "metrics-view-main-div" : "tree-view-main-div"}
      style={{
        maxWidth: groups ? "100%" : rule_view ? (metrics ? "40%" : "15%") : "18.5%",
        minWidth: groups ? "100%" : rule_view ? (metrics ? "40%" : "15%") : "18.5%",
      }}
    >
      <div className="tree-view-header d-flex">
        <span className="header-span">
          {rule_view ? "Selected " : "Select "}
          {title}
        </span>
        {/* For showing tooltip on LOBS section */}
        {isLobTooltip && (
          <>
            <span
              data-tip="Only LOBs linked to the selected sub-group can be chosen.<br/>Link additional LOBs in the sub-group to enable selection."
              data-for="lobs-info"
              style={{
                color: "#1E81E8",
                verticalAlign: "middle",
              }}
              className="material-icons-round icon-fs-14 ml-1 cursor-pointer ml-auto justify-content-center align-items-center d-flex"
            >
              info
            </span>
            <CustomReactTooltip id="lobs-info" multiline={true} />
          </>
        )}
      </div>

      {metrics ? (
        <MetricsRuleView data={treeData} />
      ) : (
        <div className="segments-tree custom-checkbox-tree">
          <CustomCheckBox
            nodes={treeData}
            checked={checkedIds}
            expanded={expandedIds}
            onCheck={checked => handleMetricsTrigger(checked)}
            showArrow={false}
            handleButtonClick={() => {}}
            onExpand={expanded => setExpandedSegments(expanded)}
            key={title}
            disabled={
              rule_view ? true : title === "LOB's" ? (forSubGroup ? checkedSubgroupIds.length === 0 : false) : false
            }
            rule_view={rule_view}
            title={title}
            isMetrics={isMetrics}
          />
        </div>
      )}
    </div>
  );
}

export default MetricCategoryTreeView;
